import React from 'react'
import './Form.css'
import Zoom from 'react-reveal/Zoom';
import { useRef } from 'react';
import emailjs from 'emailjs-com';

const FormMe = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_sgj9qkp', 'template_73ad6rj', form.current, 'YnmWpW4icHHraOU5V')
      .then((result) => {
          alert("Message Sent Succesfully");
      }, (error) => {
          alert("Message not sent succesfully")
      });
      e.target.reset();
  };
  return (
    <>
  <Zoom>
    <br />
    <div id="container">
  <h2 className="tuck pt-4 text-base "> Keep in Touch </h2>
  <br />
  <div className="underline">
  </div>
 
  <form ref={form} onSubmit={sendEmail} id="contact_form">
    <div className="name">
      <label htmlFor="name"></label>
      <input type="text" placeholder="My name is" name='name' id="name_input" required/>
    </div>
    <div className="email">
      <label htmlFor="email"></label>
      <input type="email" placeholder="My e-mail is" name='email' id="email_input" required/>
    </div>
   
    <div className="subject">
      <label htmlFor="subject"></label>
      <input type="text" placeholder="Subject" name="subject" id="text" required/>
    </div>
    <div className="message">
      <label htmlFor="message"></label>
      <textarea name="message" placeholder="I'd like to chat about" id="message_input" cols="30" rows="5" required></textarea>
    </div>
    <div className="submit">
      <input type="submit" value="Send Message" id="form_button" />
    </div>
  </form>
</div>
</Zoom>
    </>
  )
}

export default FormMe